import { DEFAULT_LOCALE, LOCALES } from '@/lib/constant'

export const ONBOARDING_SURVEY_KEY = 'acq_source' as const

type StepKey = 'role' | 'source'

export type OnboardingQuestionConfig = {
  _id: string
  stepKey: StepKey
  order: number
  type: 'single' | 'multiple'
  has_custom_input: boolean
  // Translation keys
  titleKey: string
  optionKeys: Record<string, string>
}

const QUESTION_CONFIGS: OnboardingQuestionConfig[] = [
  {
    _id: 'user_role',
    stepKey: 'role',
    order: 1,
    type: 'single',
    has_custom_input: true,
    titleKey: 'onboarding.steps.role.title',
    optionKeys: {
      founder: 'onboarding.steps.role.options.founder',
      marketer: 'onboarding.steps.role.options.marketer',
      smb: 'onboarding.steps.role.options.smb',
      dev_pm: 'onboarding.steps.role.options.dev_pm',
      other: 'onboarding.steps.role.options.other',
    },
  },
  {
    _id: 'acq_source',
    stepKey: 'source',
    order: 2,
    type: 'single',
    has_custom_input: true,
    titleKey: 'onboarding.steps.source.title',
    optionKeys: {
      social: 'onboarding.steps.source.options.social',
      twitter: 'onboarding.steps.source.options.twitter',
      tiktok: 'onboarding.steps.source.options.tiktok',
      youtube: 'onboarding.steps.source.options.youtube',
      friends: 'onboarding.steps.source.options.friends',
      producthunt: 'onboarding.steps.source.options.producthunt',
      chatgpt: 'onboarding.steps.source.options.chatgpt',
      event: 'onboarding.steps.source.options.event',
      influencer: 'onboarding.steps.source.options.influencer',
      google: 'onboarding.steps.source.options.google',
      press: 'onboarding.steps.source.options.press',
      reddit: 'onboarding.steps.source.options.reddit',
      github: 'onboarding.steps.source.options.github',
      linkedin: 'onboarding.steps.source.options.linkedin',
      newsletter: 'onboarding.steps.source.options.newsletter',
      other: 'onboarding.steps.source.options.other',
    },
  },
]

export function getOnboardingSurveyQuestions(): OnboardingQuestionConfig[] {
  return QUESTION_CONFIGS.sort((a, b) => a.order - b.order)
}

const QUESTION_MAP = new Map(
  getOnboardingSurveyQuestions().map((q) => [q._id, q]),
)

export function getOnboardingQuestionById(id: string) {
  return QUESTION_MAP.get(id)
}
